import tripEvents from './../../config/events.constant';

export default function TripDetailsRequestChangeController(
    $scope,
    tripId,
    tripFactory,
    tripAPI,
    flightsUtils,
    tripItemService,
    moment,
) {
    'ngInject';

    const vm = this;

    Object.assign(vm, {
        itemCannotBeCancelled: tripItemService.itemCannotBeCancelled,
        moment,
    });

            const isConfirmed = ($scope.tripDetails.Status === 'Held' || $scope.tripDetails.Status === 'Confirmed');
            const model = {
                    description: '',
                    payments: {
                        valid: false,
                        invalid: false,
                    },
                    items: [],
                };

            if (!tripFactory.isHash(tripId)) {
                $scope.paymentCodesValidationRequired = isConfirmed && $scope.tripDetails.HasPaymentCodes;
            }

            $scope.changesModel = angular.copy(model);
            $scope.lastFlight = flightsUtils.lastFlight;
            $scope.collectAllCities = flightsUtils.collectAllCities;
            $scope.isTrain = flightsUtils.isItemTrain;
            $scope.changeTrip = function(changeModel) {
                let data;
                const fieldsValid = (changeModel.description && changeModel.items.length > 0);
                const paymentsValid = !$scope.paymentCodesValidationRequired
                        || changeModel.payments.valid
                        || changeModel.payments.invalid;

                /**
                 * form filled correct --> change trip, statuses and hide change block
                 */
                if (fieldsValid && paymentsValid) {
                    data = {
                        TripId: tripId,
                        Changes: changeModel.description,
                        IsPaymentCodesStillValid: $scope.paymentCodesValidationRequired
                            ? changeModel.payments.valid
                            : null,
                        Items: changeModel.items,
                    };
                    tripAPI.changeTrip(data).then(function() {
                        $scope.tripDetails._changeRequestSent = true;
                        $scope.$emit(tripEvents.TRIP_SHOW_CHANGES_BLOCK, false);

                        tripFactory.tripDetails(tripId).then(function(response) {
                            $scope.tripDetails.Status = response.Status;
                            $scope.tripDetails.Locked = response.Locked;
                        });
                    });
                }
            };

            $scope.changesModel = {};

            if (isConfirmed) {
                $scope.changesModel.payments = {
                    valid: false,
                    invalid: false,
                };
            }

            $scope.selectCodeValidity = function(value) {
                if (value) {
                    $scope.changesModel.payments.invalid = false;
                } else {
                    $scope.changesModel.payments.valid = false;
                }
            };

            $scope.editChanges = function(itemId, isChecked, type) {
                const item = {
                    TripItemType: type,
                    TripItemId: itemId,
                };

                if (isChecked && !_.contains($scope.changesModel.items, item)) {
                    $scope.changesModel.items.push(item);
                }
                if (!isChecked) {
                    $scope.changesModel.items = _.reject($scope.changesModel.items, ({TripItemId}) => {
                        return TripItemId === item.TripItemId;
                    });
                }
            };

            /**
             * Cancel changes, set form in pristine state
             */
            $scope.cancel = function() {
                $scope.changesModel = angular.copy(model);
                $scope.changesForm.$setUntouched();
                $scope.changesForm.$setPristine();
                $scope.$emit(tripEvents.TRIP_SHOW_CHANGES_BLOCK, false);
            };
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/controllers/details/tripDetailsRequestChangeController.js